import "./styles/Login.css";

const LoginComponent = ({
  onSubmit,
  onChange,
  form,
  setEye,
  eye,
  loading,
  MostrarAlerta
}) => {

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img
              src="./assets/images/iconos-para-prestamos_Credixpress-05.jpg"
              alt="logo"
              className="login-logo-img"
            />
          </div>
          <h2 className="login-title">Iniciar Sesión</h2>
          <p className="login-subtitle">Bienvenido de nuevo</p>
        </div>

        <form onSubmit={onSubmit} className="login-form">
          <div className="login-form-group">
            <label htmlFor="email" className="login-label">
              <i className="bi bi-person-fill me-2"></i>Usuario
            </label>
            <input
              type="text"
              name="email"
              className="login-input"
              id="email"
              placeholder="Ingrese su usuario"
              onChange={onChange}
              value={form.email}
              autoComplete="username"
            />
          </div>

          <div className="login-form-group">
            <label htmlFor="password" className="login-label">
              <i className="bi bi-lock-fill me-2"></i>Contraseña
            </label>
            <div className="login-password-group">
              <input
                type={eye ? "text" : "password"}
                name="password"
                className="login-input login-input-password"
                id="password"
                placeholder="Ingrese su contraseña"
                onChange={onChange}
                value={form.password}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-password-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  setEye(!eye);
                }}
                aria-label={eye ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                <i className={eye ? "bi bi-eye-slash" : "bi bi-eye"}></i>
              </button>
            </div>
          </div>

          {!loading && (
            <div className="login-alert">
              <MostrarAlerta />
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cargando...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right me-2"></i>
                Ingresar
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p className="login-footer-text">
            © 2024 Sistema de Gestión Ayuu
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginComponent